import { getTechnologyFilter, isTechnologyRequired, TechnologyDropdown } from 'domain/shared/career';
import { ClearAfterUnmountWrapper, useFormContext } from 'framework/form';

const PositionSlotTechnologyDropdown = ({ disabled = false }: { disabled?: boolean }) => {
  const { data } = useFormContext();
  const specializationId = data?.specializationId as string | number | undefined;

  if (!isTechnologyRequired(specializationId)) {
    return null;
  }

  return (
    <ClearAfterUnmountWrapper>
      <TechnologyDropdown
        source="technologyId"
        label="Technology"
        isRequired
        customReduce={getTechnologyFilter(specializationId)}
        deps={[specializationId]}
        disabled={disabled}
      />
    </ClearAfterUnmountWrapper>
  );
};

export default PositionSlotTechnologyDropdown;
